import EDC from '../../../shared/globals';

EDC.Animations.PigOink = function (scene) {
  this.scene = scene;
  this.oink = null;
};

EDC.Animations.PigOink.prototype.create = function () {
  this.oink = this.scene.add.sprite(360, 430, 'oink').setOrigin(1, 0);
  this.oink.setScale(0, 0);
  this.randomDelay();
};

EDC.Animations.PigOink.prototype.scaleUp = function () {
  this.scene.tweens.add({
    targets: this.oink,
    scaleX: 1,
    scaleY: 1,
    duration: 500,
    ease: 'Sine.easeInOut',
    onComplete: this.scaleDown.bind(this),
  });
};

EDC.Animations.PigOink.prototype.scaleDown = function () {
  this.scene.tweens.add({
    targets: this.oink,
    scaleX: 0,
    scaleY: 0,
    duration: 500,
    ease: 'Sine.easeInOut',
    delay: 1000,
    onComplete: this.randomDelay.bind(this),
  });
};

EDC.Animations.PigOink.prototype.randomDelay = function () {
  const rndTime = 1000 * 5 + Math.round(Math.random() * (1000 * 15));
  this.scene.time.addEvent({ delay: rndTime, callback: this.scaleUp, callbackScope: this });
};

export default EDC.Animations.PigOink;
